import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bar_chart--sprite",
  "use": "bar_chart--sprite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bar_chart--sprite\">\n<path d=\"M3.33334 6.1335H5.33334V12.6668H3.33334V6.1335ZM7.06668 3.3335H8.93334V12.6668H7.06668V3.3335ZM10.8 8.66683H12.6667V12.6668H10.8V8.66683Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol